import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import classnames from "classnames";

import PresentationButtons from "./components/PresentationButtons";
import PresentationSliders from "./components/PresentationSliders";
import {CardBody, Col, Row} from "reactstrap";
import striptags from "striptags";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import CardContainer from "../Components/cardContainer";
import PresentationTypeSlider from "../NumericMulti/components/PresentationTypeSlider";

class Differential extends Component {

  constructor(props) {
    super(props);

    this.state = {
      validated: false,
      errorForAnswer: []
    };

    this.handlerRowUpdated = this.handlerRowUpdated.bind(this);
  }

  handlerRowUpdated(row, value){
    let {details} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    const detail = _.find(details, detail => detail.row === row);

    if (detail) {
      const index = details.indexOf(detail);
      detail.value = value;
      detail.microTime = microTime;
      details[index] = detail
    } else {
      details.push({row, value, microTime});
    }

    this.props.onDetailsUpdated(details);
    this.forceUpdate()
  }

  presentationType(row){
    const {details, question, validate} = this.props;

    const detail = _.find(details, detail => detail.row === row.id);

    const defaultProps = {
      row,
      validate,
      question,
      detail,
      onRowUpdated: this.handlerRowUpdated,
    };

    switch (question.presentationType) {
      case 'buttons':
        return <PresentationButtons
          {...defaultProps}
        />;
      case 'sliders':
        return <PresentationSliders
          {...defaultProps}
        />;
    }
  }

  validate(){
    const {details, validationTexts} = this.props;
    const {rows, required} = this.props.question;

    let validate = {
      valid: true,
      errors: []
    };

    let errorWithAnswers = [];

    if (required) {
      rows.map((row) => {
        if (!details.find((detail) => detail.row === row.id)) {
          errorWithAnswers.push(row.id);
        }
      })
    }

    if (details.length < rows.length && required) {
      validate.errors.push(validationTexts.required);
    }

    validate.valid = _.isEmpty(validate.errors);
    this.setState({
      validated: true,
      errorForAnswer: errorWithAnswers
    });

    return validate;
  }

  render() {
    const {question, details, validate, questionResponse} = this.props;
    const {validated, errorForAnswer} = this.state;

    return <div className={"p-0 cards-container"}>
      {_.map(question.rows, row => {
      return <CardContainer
          error={errorForAnswer.find((errorId) => errorId === row.id) && !questionResponse.excluding}
          component={
            this.presentationType(row)
          }
      />
      })}
    </div>
  }
}

Differential.propTypes = {
  question: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      leftContent: PropTypes.string.isRequired,
      rightContent: PropTypes.string.isRequired,
    }),).isRequired,
    rowsImage: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['buttons', 'sliders']).isRequired,
    required: PropTypes.bool.isRequired,
    scaleSize: PropTypes.number.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    row: PropTypes.number.isRequired,
    value: PropTypes.number,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Differential);